/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

const initLoginFormOption = {
  modal: true,
  bgiframe: true,
  width: '50rem',
  buttons: {
    SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal
  }
};

const loginFromCartPage = function () {
  $(document).on('click', '#message_wrapper a, #minicart-message-wrapper a', function () {
    if ($('.popover').hasClass('show')) {
      $('.popover').removeClass('show');
    }
    const $container = sorHelpers.sorModal.createContainer('#sorlogin');
    $container.load(SmartOrderRefillSettings.Urls.loginFromCartPage, function () {
      sorHelpers.sorCharLimitation.limitCharacters();
      sorHelpers.sorModal.createModal($container, initLoginFormOption);
    });
  });

  $(document).on('click', "#sorlogin button[type='submit']", function (e) {
    if (!e.detail || e.detail === 1) {
      e.preventDefault();
      const form = $(this).parents('form:first');
      if (sorHelpers.sorValidation.validateForm(form)) {
        const url = form.attr('action');
        const data = {};
        form.serializeArray().forEach(function (param) {
          data[param.name] = param.value;
        });

        Object.keys(data).forEach(function (key) {
          data[key] = sorHelpers.sorValidation.sanitizeString(data[key]);
        });

        $.ajax({
          type: 'POST',
          url: url,
          data: data,
          success: function (response) {
            if (!response) {
              sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR, false);
            } else if (response.success) {
              if ($('#loginFromCartError').length) {
                $('#loginFromCartError').remove();
              }
              window.location = response.url;
            } else if (!$('#loginFromCartError').length) {
              form.prepend(
                '<div id="loginFromCartError" class="error-form">' + SmartOrderRefillSettings.Resources.SOR_LOGINFROMCART_ERROR + '</div>'
              );
            }
          },
          error: function (err) {
            if (err.responseJSON && err.responseJSON.redirectURL) {
              window.location.href = err.responseJSON.redirectURL;
            } else {
              sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
            }
          }
        });
      }
    }
  });

  $(document).on('cart:update', 'body', function (e, response) {
    // SFRA
    if (!response.error && response.basket && !response.basket.items.length) {
      $('#message_wrapper').parent().remove();
    }
  });
};

module.exports = {
  loginFromCartPage: loginFromCartPage
};
